import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { RxState } from '@rx-angular/state';
import { combineLatest, distinctUntilChanged, map, Observable, startWith, timer } from 'rxjs';
import { AppMainState } from 'src/app/types/state/app-main-state.interface';
import { APP_MAIN_RX_STATE, GlobalState, GLOBAL_RX_STATE } from 'src/app/app-state.tokens';
import { MainState } from 'src/app/types/state/app-main-state.interface';

const MIN_SPLASH_SCREEN_MS = 2200;
const MAX_SPLASH_SCREEN_MS = 8000;

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SplashScreenComponent {
  
  show$: Observable<boolean>;
  offline$: Observable<boolean>;

  constructor(
    @Inject(GLOBAL_RX_STATE) private globalState: RxState<GlobalState>,
    @Inject(APP_MAIN_RX_STATE) private appMainState: RxState<AppMainState>,
  ) {
    const ms$ = this.globalState.select("mainState");
    this.offline$ = ms$.pipe(map(i => i === MainState.OFFLINE));
    const initializationCompleted$ = this.appMainState
      .select('initializationCompleted')
      .pipe(
        map(Boolean),
        startWith(false),
      );
    const startupTimeoutReached$ = timer(MAX_SPLASH_SCREEN_MS).pipe(
      map(() => true),
      startWith(false),
    );
    const minDisplayTimeReached$ = timer(MIN_SPLASH_SCREEN_MS).pipe(
      map(() => true),
      startWith(false),
    );

    this.show$ = combineLatest([
      initializationCompleted$,
      minDisplayTimeReached$,
      startupTimeoutReached$,
    ]).pipe(
      map(([initializationCompleted, minDisplayTimeReached, startupTimeoutReached]) =>
        !(initializationCompleted && minDisplayTimeReached) && !startupTimeoutReached,
      ),
      distinctUntilChanged(),
    );
  }
}
